import { Modal, Text } from "@mantine/core";
import { useParams } from "react-router-dom";
import { Button } from "src/components/shared/Button/Button";
import { useTriggerAutoSave } from "src/generator/hooks/useTriggerAutoSave";
import { useIsNewEntry, usePostApi } from "src/hooks";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setDeisolatedTimeModalOpen } from "src/redux/slices/generatorFeaturesSlice";
import { setDeisolate } from "src/redux/slices/generatorSlice";
import { Flex } from "src/styled";
import { getYachtId } from "src/utils";

const DeisolatedTimeModal = () => {
  const dispatch = useDispatch();
  const { lbeidOrPartId, lbid } = useParams();
  const { deisolatedTimeModalData } = useSelector(
    s => s.generatorFeaturesSlice,
  );
  const triggerAutoSave = useTriggerAutoSave();
  const isNewEntry = useIsNewEntry(false);
  const { post } = usePostApi();
  const handleAcknowledge = async () => {
    if (!deisolatedTimeModalData) return;

    await post({
      request: "record-history-action",
      body: {
        params: {
          yachtid: getYachtId(),
          lbid,
          lbeid: lbeidOrPartId,
          action: `User acknowledged ${deisolatedTimeModalData.timeKey} hours Deisolate popup`,
        },
      },
    });

    dispatch(setDeisolate({ key: deisolatedTimeModalData.timeKey }));
    dispatch(setDeisolatedTimeModalOpen(null));
    setTimeout(() => {
      triggerAutoSave();
    }, 500);
  };

  if (isNewEntry) return null;
  const isOpen = Boolean(deisolatedTimeModalData);

  return (
    <Modal opened={isOpen} onClose={handleAcknowledge} title="Warning">
      <Text>Check for anything that is still isolated.</Text>
      <Flex justify="flex-end">
        <Button onClick={handleAcknowledge}>Okay</Button>
      </Flex>
    </Modal>
  );
};
export default DeisolatedTimeModal;
